import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import { useSeo } from "@/hooks/useSeo";
import { CallNowButton } from "@/components/CTAButtons";
import { business } from "@/data/site";

const NotFound = () => {
  useSeo({ title: `Page Not Found | ${business.name}`, description: "The page you're looking for could not be found." });
  return (
    <section className="max-w-2xl mx-auto px-4 py-24 sm:py-32 text-center" data-testid="not-found">
      <div className="font-display font-black text-8xl text-[#059669] mb-4">404</div>
      <h1 className="font-display font-black text-3xl sm:text-4xl tracking-tight mb-4">Page Not Found</h1>
      <p className="text-[#475569] text-lg mb-8">The page you're looking for doesn't exist or has moved. Let's get you back on track.</p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Link to="/" className="inline-flex items-center justify-center gap-2 bg-[#0F2E4C] text-white font-bold uppercase tracking-wide px-6 py-3 border-2 border-[#0F2E4C] hover:bg-[#1A4A6B] transition-colors" data-testid="notfound-home-btn">
          <Home className="w-5 h-5" /> Back to Home
        </Link>
        <CallNowButton testid="notfound-call-btn" />
      </div>
    </section>
  );
};

export default NotFound;
